<template>
    <div class="w-100 h-100 text-center">
        <br /><br />
            <h2 class="tw-mb-0 text-aegis-dk">
                Subject Microscopy Summary Export Download
            </h2>
            <br />
            <p v-if="loading == true">
                <i class="fa fa-spinner fa-spin"></i> Fetching...
            </p>
            <p v-else>
                {{ filename }} <br /><br />
                <b-button variant="success" @click="download_report"><i class="fa fa-download"></i> Download Export</b-button>
            </p>
    </div>
</template>


<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import { HTTP } from "@/utilities/http-common";
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import HandleErrors from "@/utilities/handle-errors";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    components: {},
    data: function () {
        return {
            download_link: process.env.VUE_APP_AXIOS_BASE_URL + '/kenya/subject-microscopy-summary-reports/'+this.$route.params.reportID+'/',
            loading: true,
            filename: ''
        };
    },
    computed: {
    },
    watch: {
    },
    mounted: function () {
        let that = this;
        HTTP.get("/kenya/subject-microscopy-report-details", {params: {report_id: that.$route.params.reportID}})
            .then((response) => {
                that.filename = response.data.filename;
                that.loading = false;
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
            });
    },
    methods: {
        download_report: function(){
            let that = this;
            HTTP.get(this.download_link, { responseType: "arraybuffer" })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", that.filename);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        }
    },
};
</script>

<style>
</style>